import { Box, Flex, type BoxProps, Switch, Text, Title } from '@mantine/core'
import { type PropsWithChildren } from 'react'

import { useTranslation } from '@flecto/translations'

import { useTaxProfileFormContext } from '../TaxesFormProvider/TaxesFormProvider'

export function TaxesDefaultTaxableSection(props: PropsWithChildren<BoxProps>) {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_taxes' })
  const { t: tValidation } = useTranslation('shared', {
    keyPrefix: 'validation',
  })
  const form = useTaxProfileFormContext()

  return (
    <Box {...props}>
      <Flex align='center' justify='space-between'>
        <Box>
          <Title order={4}>{t('taxes_default_taxable_section.title')}</Title>
          <Text color='dimmed' mb='md'>
            {t('taxes_default_taxable_section.description')}
          </Text>
        </Box>
        <Switch
          checked={form.getInputProps('default_taxable').value}
          onChange={(e) =>
            form.setFieldValue('default_taxable', e.currentTarget.checked)
          }
        />
      </Flex>
      {form.getInputProps('default_taxable').error && (
        <Text color='red' mt='sm'>
          {tValidation('required')}
        </Text>
      )}
    </Box>
  )
}
